import React, { useContext, useEffect, useState } from 'react';
import UserAuthLayout from '../../../Layout/UserAuthLayout';
import { Link } from 'react-router-dom';
import {
  FaArrowCircleRight,
  FaList,
  FaCheckDouble,
  FaSpinner,
  FaClock,
  FaTimes,
  FaFileInvoiceDollar,
} from 'react-icons/fa';
import WallateModal from '../WallateModal/WallateModal';
import { AuthUserApi } from '../../../utils/api';
import ValueUpdateCard from '../../../Components/ValueUpdateCard';
import LatestOrderList from '../../Escrow/LatestEscrowList';
import { useTranslation } from '../../../Context/LanguageContext';

const Dashboard = () => {
  const { t } = useTranslation();
  const [data, setData] = useState('');
  const [load, setLoad] = useState(true);
  const [dashboardCount, setDashboardCount] = useState({});
  const [escrows, setEscrows] = useState([]);

  const getData = async () => {
    try {
      const listResponse = await AuthUserApi.get(`/user/dashboard-data`);
      const { status, data } = listResponse;
      if (status === 200 && data.dashboardCount !== undefined) {
        setDashboardCount(data.dashboardCount);
        setEscrows(data.escrows);
      }
    } catch (e) {
      console.log(`😱 Axios request failed: ${e}`);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    const url = 'https://api.spacexdata.com/v4/launches/next';
    //setLoad(true);
    fetch(url)
      .then((response) => response.json())
      .then((data) => {
        setData(data);
        setLoad(false);
      });
    //setLoad(false);
  }, []);

  return (
    <>
      <UserAuthLayout>
        <div className='container-fluid py-4'>
          <div className='row'>
            <div className='col-12 col-sm-12 col-md-8'>
              <div className='row'>
                <div className='col-xl-6 col-sm-6 col-12 mb-xl-3 mb-4'>
                  <ValueUpdateCard
                    Count={dashboardCount?.allOrder}
                    Title={t('allOrder')}
                    Icon={<FaList size={22} />}
                  />
                </div>
                <div className='col-xl-6 col-sm-6 col-12 mb-xl-3 mb-4'>
                  <ValueUpdateCard
                    Count={
                      dashboardCount?.totalAmt?.invoiceAmt
                        ? parseFloat(dashboardCount?.totalAmt?.invoiceAmt) +
                          parseFloat(dashboardCount?.totalAmt?.additionalAmt)
                        : 0
                    }
                    Title={t('paymentReceived')}
                    Icon={<FaFileInvoiceDollar size={22} />}
                  />
                </div>
                <div className='col-xl-6 col-sm-6 col-12 mb-xl-3 mb-4'>
                  <ValueUpdateCard
                    Count={dashboardCount?.completedOrder}
                    Title={t('completedOrder')}
                    Icon={<FaCheckDouble size={22} />}
                  />
                </div>
                <div className='col-xl-6 col-sm-6 col-12 mb-xl-3 mb-4'>
                  <ValueUpdateCard
                    Count={dashboardCount?.inProgressOrder}
                    Title={t('processingOrder')}
                    Icon={<FaSpinner size={22} />}
                  />
                </div>
                <div className='col-xl-6 col-sm-6 col-12 mb-xl-3 mb-4'>
                  <ValueUpdateCard
                    Count={dashboardCount?.pendingOrder}
                    Title={t('pendingOrder')}
                    Icon={<FaClock size={22} />}
                  />
                </div>
                <div className='col-xl-6 col-sm-6 col-12 mb-xl-3 mb-4'>
                  <ValueUpdateCard
                    Count={dashboardCount?.rejectedOrder}
                    Title={t('rejectedOrder')}
                    Icon={<FaTimes size={22} />}
                  />
                </div>
              </div>
              <div className='row'>
                <div className='col-12 mb-4'>
                  <div className='card-glass-mini'>
                    <div className='card-header p-3 pb-0 bg-transparent border-0'>
                      <h5 className='font-weight-bolder mb-0' style={{ color: 'var(--text-primary)' }}>
                        {t('escrow')}
                      </h5>
                    </div>
                    <div className='card-body p-3'>
                      <p className='text-muted'>
                        {t('escrowDesc')}
                      </p>
                      <Link to='/create-eccrow/0' className='btn btn-gold mb-0'>
                        {t('createEscrow')} <FaArrowCircleRight className='ms-1' />
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className='col-12 col-sm-12 col-md-4 d-flex align-items-stretch'>
              <div className='card-glass-mini mb-4 w-100'>
                <div className='card-body pt-4 p-3'>
                  <h6 className='text-uppercase text-xs font-weight-bolder mb-3 text-gold'>
                    {t('latestOrders')}
                  </h6>
                  <ul className='list-group'>
                    <LatestOrderList escrows={escrows} />
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <WallateModal />
      </UserAuthLayout>
    </>
  );
};

export default Dashboard;
